<template>
  <section id="intro">
    <div class="container content">
      <h2>{{prismic_data.intro_title[0].text}}</h2>
      <p v-for="(paragraph, index) in prismic_data.intro_text" v-bind:key="index">{{paragraph.text}}</p>
    </div>
    <div id="videos" class="video-intro" :style="{backgroundColor: prismic_data.intro_background_color}">
      <div class="bg-opacity" v-show="!playingVideo"></div>
      <div
        class="bg"
        v-show="!playingVideo"
        :style="[windowSize > 768 ? { backgroundImage: 'url(' + prismic_data.video_background_image.url + ')' } : { backgroundImage: 'url(' + prismic_data.video_background_image_mobile.url + ')' }]"
      >
        <div class="inner-bg">
          <h3>{{prismic_data.video_intro_title}}</h3>
          <button @click="playVideo">
            <img src="../assets/img/play-icon.png" alt />
          </button>
        </div>
      </div>
      <div class="videos-content container">
        <div
          class="single-video"
          v-for="(video, index) in prismic_data.videos"
          v-bind:key="index"
          :ref="'video-tab-' + index"
        >
        <prismic-embed :field="video.video_embed"/>
        </div>
      </div>
    </div>
    <nav id="menu">
      <div class="container">
        <ul>
          <li v-for="(video, index) in prismic_data.videos" v-bind:key="index">
            <a
              href
              class="video-select"
              :class="[
              'video-select-' + index,
              index === 0 ? 'active' : ''
              ]"
              @click.prevent="toggleTab(index)"
              :ref="'video-select-' + index"
            >{{video.tab_title}}</a>
          </li>
        </ul>
      </div>
    </nav>
  </section>
</template>

<script>
export default {
  name: "VideoSection",
  props: {
    prismic_data: {
      type: Object,
      required: true,
    },
    windowSize: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      playingVideo: false,
      lastSelectedVideo: 0,
    };
  },
  methods: {
    playVideo() {
      this.playingVideo = true;
      this.$refs["video-tab-0"][0].className += " active";
    },
    toggleTab(index) {
      this.playingVideo = true;

      let videoContainer = document.getElementsByClassName("single-video");
      let videoSelect = document.getElementsByClassName("video-select");

      // remove all active classes from the tab videos and the tab video selector
      for (let i = 0; i < videoContainer.length; i++) {
        videoContainer[i].className = videoContainer[i].className.replace(
          " active",
          ""
        );
        videoSelect[i].className = videoSelect[i].className.replace(
          " active",
          ""
        );
        // stop all videos
        videoContainer[this.lastSelectedVideo].getElementsByTagName(
          "iframe"
        )[0].src = videoContainer[this.lastSelectedVideo].getElementsByTagName(
          "iframe"
        )[0].src;
      }

      this.$refs["video-tab-" + index][0].className += " active"; // add active class to video-tab
      this.$refs["video-select-" + index][0].className += " active"; // add active class to video-select

      this.lastSelectedVideo = index;
    },
  },
};
</script>

<style lang="scss" scoped>
#intro .content {
  padding: 128px 168px;
  @media (max-width: $breakpoint-md) {
    padding: 128px 64px;
  }
  @media (max-width: $breakpoint-sm) {
    padding: 60px 0 90px 0;
  }
}

.content {
  h2 {
    color: $color-purple;
    line-height: 53px;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 44px;
    @media (max-width: $breakpoint-sm) {
      margin-bottom: 26px;
      padding: 0 10px;
      line-height: 47px;
    }
  }

  p {
    text-align: center;
    line-height: 32px;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    @media (max-width: $breakpoint-sm) {
      padding: 0 24px;
    }
  }
}

.videos-content {
  .single-video {
    display: none;
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
    width: 100%;
    &.active {
      display: block;
    }
    /deep/ iframe {
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      position: absolute;
    }
  }
}

.video-intro {
  position: relative;

  .bg-opacity {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  .bg {
    height: 615px;
    width: 662px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: $breakpoint-sm) {
      width: 100%;
      height: 322px;
    }
  }
}

.inner-bg {
  h3 {
    line-height: 62px;
    color: $color-white;
    opacity: 0.9;
    text-transform: uppercase;
    text-align: center;
    @media (max-width: $breakpoint-sm) {
      padding: 0 10px;
      line-height: 40px;
      position: relative;
      z-index: 1;
    }
  }

  button {
    margin: 0 auto;
    display: block;
    position: relative;
    top: -36px;
    outline: none;
    img {
      width: 100%;
    }
    @media (max-width: $breakpoint-sm) {
      width: 82px;
      height: 82px;
      top: -20px;
    }
  }
}

#menu {
  border-bottom: 1px solid $color-dark-blue;
}

.container {
  @media (max-width: $breakpoint-sm) {
    padding: 0 16px;
  }
}

ul {
  list-style: none;
  padding: 0;
  display: flex;
  padding-top: 20px;
  padding-bottom: 10px;
  li {
    border-bottom: 4px solid transparent;
    flex: 0 1 100px;
    a {
      padding-bottom: 10px;
      @media(max-width: $breakpoint-xs){
        font-size: 13px;
      }
      &.active {
        font-weight: bold;
        color: $color-black;
        border-bottom: 4px solid $color-purple;
      }
    }
  }
}
</style>